module.exports = __webpack_public_path__ + "img/app_android_d.7ab60925.png";